import { formatNumberWithThinSpaces } from 'helpers/helpers';

const UsersLegend = ({ className, totalSum, partialSum, title }) => {
  const percentValue =
    totalSum === 0 ? 0 : Math.round((partialSum / totalSum) * 1000) / 10;

  return (
    <div className={className}>
      {formatNumberWithThinSpaces(partialSum)} ({percentValue}%)
      <span> - {title}</span>
    </div>
  );
};

export default UsersLegend;
